var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trace-scan"},[(_vm.loading)?_c('div',{staticClass:"state"},[_vm._v("加载中…")]):(_vm.error)?_c('div',{staticClass:"state error"},[_vm._v(_vm._s(_vm.error))]):_c('trace-view',{attrs:{"info":_vm.info}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }